import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import OperatorBtn from "components/fragments/OperatorBtn";
import CustomBtn from "components/fragments/CustomBtn";
import { useDispatch } from "react-redux";
import { kitchenHandler } from "../../redux/handlers";

export default function ModalKitchenCancelUnit({
  modalOpenObj,
  seletedUnitsObj,
  cancelOrderListObj,
  syncAfterHandle,
  businessSlug,
  ...props
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (seletedUnitsObj) {
      const { foodList, selectedList } = seletedUnitsObj;

      const items = selectedList.map((index) => {
        const food = foodList[index];
        return {
          index,
          id: food.id,
          maxUnit: food.unit,
          unit: 0,
          name: food.name,
        };
      });

      setSelectedItems(items);
    }
  }, [seletedUnitsObj]);

  const handleUnitChange = (index, value) => {
    setSelectedItems((prev) => {
      const updated = [...prev];
      const item = updated[index];

      if (value >= 0 && value <= item.maxUnit) {
        updated[index] = { ...item, unit: value };
      }

      return updated;
    });
  };

  const handleConfirm = async () => {
    for (const item of selectedItems) {
      if (item.unit > 0) {
        const data = { quantity_removed_append: item.unit };
        await dispatch(
          kitchenHandler.handleCancelingOrderItem(businessSlug, data, item.id)
        );
      }
    }

    await syncAfterHandle();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={() => modalOpenObj.setModalOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white min-w-[min(38.09vw,390px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-18 text-[var(--color-black-2)] text-center">
            <div className="text-18 font-[700]">ยืนยันการยกเลิกเมนู</div>

            {/* แสดงรายการที่เลือกทั้งหมด */}
            <div className="max-h-[50vh] overflow-y-auto">
              {selectedItems.map((item, index) => (
                <div
                  key={index}
                  className="mt-[min(1.95vw,20px)] border-b pb-3"
                >
                  <div className="text-24 font-[700] text-[var(--color-green)]">
                    {item.name}
                  </div>
                  <div className="flex justify-center items-center mt-[min(2.05vw,21px)]">
                    <div className="text-16 mr-[min(4.00vw,41px)]">จำนวน</div>
                    <div className="flex items-center gap-[min(2.44vw,25px)]">
                      <OperatorBtn
                        onClick={() => handleUnitChange(index, item.unit - 1)}
                        className={`aspect-square min-w-[min(3.13vw,32px)] h-fit btn-grey-5`}
                        content={
                          <div>
                            <img
                              className="object-contain aspect-square w-[min(0.78vw,8px)]"
                              src="/img/icons/icon-minus-black.svg"
                              alt=""
                            />
                          </div>
                        }
                        isActive={item.unit > 0}
                      />
                      <div className="poppins text-20 font-[600]">
                        {item.unit}
                      </div>
                      <OperatorBtn
                        onClick={() => handleUnitChange(index, item.unit + 1)}
                        className={`aspect-square min-w-[min(3.13vw,32px)] h-fit btn-grey-5`}
                        content={
                          <div>
                            <img
                              className="object-contain aspect-square w-[min(0.78vw,8px)]"
                              src="/img/icons/icon-plus-black.svg"
                              alt=""
                            />
                          </div>
                        }
                        isActive={item.unit < item.maxUnit}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex justify-center gap-[min(2.44vw,25px)] mt-[min(1.95vw,20px)]">
              <CustomBtn
                onClick={() => {
                  modalOpenObj.setModalOpen(false);
                }}
                className={`leading-[0.8] w-fit min-w-[min(11.13vw,114px)] h-[min(4.88vw,50px)] text-18 text-[#6D788D] font-[600] rounded-[min(0.78vw,8px)] btn-second-2-active shadow-none`}
                btntxt={"ยกเลิก"}
              />
              <CustomBtn
                onClick={async () => {
                  if (!seletedUnitsObj) {
                    return modalOpenObj.setModalOpen(false);
                  }

                  const { setSelectedList } = seletedUnitsObj;
                  await handleConfirm();
                  setSelectedList([]);
                  modalOpenObj.setModalOpen(false);
                }}
                className={`leading-[0.8] w-fit min-w-[min(11.13vw,114px)] h-[min(4.88vw,50px)] text-18 text-white font-[600] rounded-[min(0.78vw,8px)] ${"btn-main-active"} shadow-none`}
                btntxt={"ยืนยัน"}
              />
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
